import { render } from "./ApartmentLayout.vue?vue&type=template&id=45f94020"
import script from "./ApartmentLayout.vue?vue&type=script&lang=js"
export * from "./ApartmentLayout.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__